import { CKContainerProps } from 'clearkit';

import { PageLayout } from '../PageLayout/PageLayout';

export const PageWrapper = ({ children, ...rest }: CKContainerProps) => (
  <PageLayout {...rest} className="@container/list">
    {children}
  </PageLayout>
);
